package ai.wagemix.net.models

import com.fsryan.foundation.models.FSStringEnumerated
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport


@OptIn(ExperimentalJsExport::class)
@JsExport
enum class WMSharedMixPurpose(override val stringValue: String): FSStringEnumerated {
    JD("jd"), Social("social"), Unknown("unknown");
}